/* src/app/components/analytics/auto-redaction/auto-redaction-details/auto-redaction-details.component.scss */
table {
  width: 100%;
}
.rule-type {
  width: 92px;
}
.preset-type {
  width: 106px;
}
.delete-icon-container {
  width: 44px;
}
.mat-mdc-row:hover {
  cursor: pointer;
  background-color: rgba(180, 180, 180, 0.2);
}
/*# sourceMappingURL=auto-redaction-details.component.css.map */
